import { useOutletContext } from "react-router-dom";
import TINNRLayout from "../type";
import TOutletContext from "@/cms/types/TOutletContext";
import { useEffect } from "react";
import { innerLanguageVersion, metaDataLanguageVersion, outerNameDescriptionLanguageVersion } from "@/utilities/LanguageVersionSelectorShortcut";
import ContactInfo from "@/components/ContactInfo";
import ContactForm from "@/components/ContactForm";
import PageBanner from "@/components/PageBanner";
import { isEmpty } from "lodash";
import EResourceType from "@/cms/enums/EResourceType";
import RMDRComponentSanitizer from "@/components/RMDRComponentSanitizer";


const INNR_001 = ( props:TINNRLayout ) => {
    console.log("INNR_001.rendered: ", props);

    const { siteSettingPayload, _showLoader, _hideLoader } = useOutletContext<TOutletContext>();

    useEffect(
        () => {
            console.log("INNR_001.useEffect.1: ", props);

            setTimeout(() => { _hideLoader(); }, 100);
            return () => {
                _showLoader();
            }
        },[]
    )

    const siteSettingsLanguageVersion = outerNameDescriptionLanguageVersion(siteSettingPayload.languageVersions);
    const languageVersion = outerNameDescriptionLanguageVersion(props.contentDetailPayload.languageVersions);
    const languageVersionInner = innerLanguageVersion(props.contentDetailPayload.languageVersions);
    const googleMaps = metaDataLanguageVersion("googleMaps", props.contentDetailPayload.languageVersions);
    
    if ( !props.contentDetailPayload?.languageVersions || isEmpty(props.contentDetailPayload?.languageVersions) ) return null;

    return (
        <>
            <PageBanner title={languageVersion?.name} resources={props.contentDetailPayload.resources} resourceType={EResourceType.PARALLAX} />
            <ContactInfo languageVersions={props.contentDetailPayload.languageVersions} />
            <div className="contact-form pb-70">
                <RMDRComponentSanitizer
                    languageVersion={languageVersionInner}
                    className="contact-title"
                    valueExpr="value"
                    variant="div"
                />
                <ContactForm />
            </div>
            {
                googleMaps && (
                    <iframe 
                        title={`${siteSettingsLanguageVersion?.name} Google Maps`}
                        src={googleMaps} 
                        width="100%" 
                        height="600" 
                        style={{border:0}} 
                        allowFullScreen={true} 
                        loading="lazy" 
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                )
            }
      </>
    );
}

export default INNR_001;
